import React from 'react';
import ErrorBoundary from 'Views/Onboarding/Components/ErrorBoundary';
import OnboardingContainer from './OnboardingContainer';

const Onboarding = () => {
  return (
    <ErrorBoundary>
      <OnboardingContainer />
    </ErrorBoundary>
  );
};

export default Onboarding;
